import * as React from "react";
const Play = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.83519e-08 6.5L1.06863e-08 3.99379C1.16889e-09 0.882157 2.20349 -0.392065 4.89977 1.16375L7.0751 2.41686L9.25043 3.66996C11.9467 5.22578 11.9467 7.77422 9.25043 9.33004L7.0751 10.5831L4.89977 11.8362C2.20349 13.3921 3.5535e-08 12.1178 2.60176e-08 9.00621L1.83519e-08 6.5Z"
      fill="#FF6A4B"
    />
  </svg>
);
export default Play;
